import {
  TopAppBar,
  TopAppBarActionItem,
  TopAppBarFixedAdjust,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarTitle
} from "@rmwc/top-app-bar";
import "@rmwc/top-app-bar/styles";
import { Fab } from "@rmwc/fab";
import "@rmwc/fab/styles";
import { Drawer, DrawerContent, DrawerHeader, DrawerSubtitle, DrawerTitle } from "@rmwc/drawer";
import "@rmwc/drawer/styles";
import "@rmwc/list/styles";
import { List, ListItem, ListItemGraphic } from "@rmwc/list";
import { selectBackVisible } from "App/Header/Store/selectors";
import { selectToken, selectTokenAdmin, selectTokenValue, selectUser } from "App/Authentification/Store/selectors";
import { PRIMARY_COLOR } from "App/Constants";
import { setBackVisible } from "App/Header/Store/actions";
import { clearToken, clearTokenAdmin } from "App/Authentification/Store/actions";
import { INITIAL_STATE } from "App/Authentification/Store/constants";
import { showError } from "App/Toast/Toast";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import logoIsipay from "Resources/ISIPAY_LOGO.png";
import { LanguageSelector } from "Accueil/Components/LanguageSelector";

import "./Header.css";

// #region FONCTION COMPOSANT
/**
 * Composant permettant d'afficher le header
 * @category Header
 */
function Header() {
  // #region INITIALISATION
  // Initialisation des states
  const [menuOpen, setMenuOpen] = useState(false);

  const [languageOpen, setLanguageOpen] = useState(false);
  
  // AYB 2025.11.25 - Référence pour suivre si c'est le premier rendu
  const isFirstRender = useRef(true);

  // Initialisation des sélecteurs
  const backVisible = useSelector((state) => selectBackVisible(state));
  const token = useSelector((state) => selectToken(state));
  const tokenAdmin = useSelector((state) => selectTokenAdmin(state));
  const tokenValue = useSelector((state) => selectTokenValue(state));
  const userInfos = useSelector((state) => selectUser(state));

  // Récupération de l'historique
  const history = useHistory();
  const location = useLocation();

  // Traduction i18n
  const { t } = useTranslation();

  // Initialisation du dispatch
  const dispatch = useDispatch();

  // Calcul de la visibilité du bouton de connexion
  const showConnexionButton = (!token || !token.token) || (!tokenAdmin || !tokenAdmin.tokenAdmin);
  // #endregion

  // #region EVENTS
  // Clic sur le bouton de connexion
  const handleClickConnexion = () => {
    history.push({
      pathname: "/connexion",
      state: { mapParams: location.search }
    });
  };

  // Navigation dans le menu
  const handleNavigate = (pathname) => {
    dispatch(setBackVisible(true));
    setMenuOpen(false);
    history.push(pathname);
  };

  //AYB 25.12.04 Déconnexion de l'utilisateur
  const handleLogout = () => {
    dispatch(clearToken(INITIAL_STATE.token));
    dispatch(clearTokenAdmin(INITIAL_STATE.tokenAdmin));
    setMenuOpen(false);
    history.push({ pathname: "/" });
  };
  //fin AYB

  // AYB 25.12.04: Ne plus afficher le message de session expirée
  // Affichage du message de déconnexion si nécessaire
  /*useEffect(() => {
    // AYB 2025.11.25 - Ignorer le premier rendu pour éviter d'afficher le message au chargement initial
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    
    if (showConnexionButton && location.pathname !== "/connexion") {
      setTimeout(() => {
        showError(t("accueil.disconnected"));
      }, 500);
    }
  }, [showConnexionButton, location.pathname, t]);*/
  //fin AYB
  // #endregion

  // #region INTERFACE
  // Masquer le header sur la page de connexion
  if (location.pathname === "/connexion") {
    return null;
  }

  return (
    <>
      <TopAppBar
        className="Header-Container"
        fixed
      >
        <TopAppBarRow>
          <TopAppBarSection alignStart>
            {!backVisible && (
              <>
               
                <TopAppBarActionItem
                  icon="menu"
                  onClick={() => setMenuOpen(true)}
                  style={{ color: PRIMARY_COLOR }}
                />
                
                <button
                  onClick={() => setLanguageOpen(true)}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: PRIMARY_COLOR
                  }}
                >
                  <img
                    src={t("accueil.languageIcon")}
                    alt={t("accueil.labelLanguage")}
                    style={{ width: 24, height: 24 }}
                  />
                </button>
              </>
            )}
            {backVisible && (
              <TopAppBarActionItem
                icon="arrow_back_ios_new"
                onClick={() => history.replace("/")}
                style={{ color: "#000" }}
              />
            )}
          </TopAppBarSection>
          
          <TopAppBarTitle className="Header-SectionContainer">
            <img
              alt="logo ISIPAY"
              className="Header-Logo"
              src={logoIsipay}
            />
          </TopAppBarTitle>

          <TopAppBarSection alignEnd>
            {showConnexionButton && (
              <div className="Header-ConnexionButtonContainer">
                <Fab
                  icon="login"
                  label={t("accueil.connection")}
                  onClick={handleClickConnexion}
                />
              </div>
            )}
            {!showConnexionButton && backVisible && (
              <div className="Header-EmptyContainer" />
            )}
            {!showConnexionButton && !backVisible && (
              <div className="Header-EmptyContainer-Double" />
            )}
          </TopAppBarSection>
        </TopAppBarRow>
      </TopAppBar>

      {/* Menu Drawer */}
      <Drawer
        modal
        onClose={() => setMenuOpen(false)}
        open={menuOpen}
        style={{ position: "absolute", bottom: 0 }}
      >
        <DrawerHeader>
          <DrawerTitle>
            {t("accueil.labelMenu")}
          </DrawerTitle>
          {tokenValue && (userInfos?.username || userInfos?.firstName || userInfos?.name) && (
            <DrawerSubtitle>
              {t("accueil.hello")} {[userInfos.firstName, userInfos.name].filter(Boolean).join(" ") || userInfos.username}
            </DrawerSubtitle>
          )}
        </DrawerHeader>
        <DrawerContent>
          <List>
            {tokenValue &&
              <>
                {/* Mon compte */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <ListItemGraphic icon={{ icon: "person" }} style={{ alignSelf: "center", marginRight: 0, marginLeft: 15 }} />
                  <ListItem onClick={() => handleNavigate("/user")}>
                    {t("accueil.myAccount")}
                  </ListItem>
                </div>
                {/* Historique d'achats */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <ListItemGraphic icon={{ icon: "payments" }} style={{ alignSelf: "center", marginRight: 0, marginLeft: 15 }} />
                  <ListItem onClick={() => handleNavigate("/achats")}>
                    {t("accueil.historic")}
                  </ListItem>
                </div>
                {/* Déconnexion */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <ListItemGraphic icon={{ icon: "logout" }} style={{ alignSelf: "center", marginRight: 0, marginLeft: 15 }} />
                  <ListItem onClick={() => handleLogout()}>
                    {t("accueil.logout")}
                  </ListItem>
                </div>
              </>
            }
          </List>
        </DrawerContent>
      </Drawer>

      
      <LanguageSelector open={languageOpen} onOpenChange={setLanguageOpen} />

      <TopAppBarFixedAdjust />
    </>
  );
  // #endregion
};
// #endregion

export { Header };

